import PageShell from "@/components/PageShell";
import Seo from "@/components/Seo";

export default function Privacy() {
  return (
    <>
      <Seo
        title="Privacy Policy | Juwai Morning Teer"
        description="Read how Juwai Morning Teer handles data. We do not collect personal information from visitors browsing publicly available result pages."
        path="/privacy-policy"
      />
      <PageShell>
        <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight text-emerald-950">
          Privacy Policy
        </h1>
        <div className="prose prose-sm sm:prose-base max-w-none mt-4 text-slate-700 leading-relaxed">
          <p>
            Juwai Morning Teer does not intentionally collect personal
            information from visitors. Basic anonymous analytics data (such as
            page views or referrer, if enabled) may be processed for the
            purpose of understanding usage trends.
          </p>
          <p>
            We do not sell or share user data with third parties. Cookies used
            on the site, if any, are limited to essential functionality such as
            maintaining an admin login session.
          </p>
          <p>
            For questions about this policy, please contact us via the{" "}
            <a href="/contact" className="text-emerald-800 underline">
              Contact
            </a>{" "}
            page.
          </p>
        </div>
      </PageShell>
    </>
  );
}
